import { render, staticRenderFns } from "./home-jianbao.vue?vue&type=template&id=6a5f9f34&"
import script from "./home-jianbao.vue?vue&type=script&lang=js&"
export * from "./home-jianbao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports